import { Injectable } from '@angular/core';
import {
  IndividualConfig,
  ToastrService as ngxToastrService,
} from 'ngx-toastr';
import { TOASTER_MESSAGE, TOASTER_TITLE } from '@shared/config';

@Injectable()
export class ToastrService {
  MESSAGE = TOASTER_MESSAGE;
  TITLE = TOASTER_TITLE;
  constructor(private toastr: ngxToastrService) {}

  info(text: string, title?: string, override?: Partial<IndividualConfig>) {
    return this.toastr.info(text, title, override);
  }

  success(text: string, title?: string, override?: Partial<IndividualConfig>) {
    return this.toastr.success(text, title, override);
  }

  warning(text: string, title?: string, override?: Partial<IndividualConfig>) {
    return this.toastr.warning(text, title, override);
  }

  error(text: string, title?: string, override?: Partial<IndividualConfig>) {
    return this.toastr.error(text, title || this.TITLE.error, override);
  }

  show(text: string, title?: string, override?: Partial<IndividualConfig>) {
    return this.toastr.show(text, title, override, 'toast-default');
  }

  clear(id?: number) {
    this.toastr.clear(id);
  }
}
